<div id="verloopChatBox" class="verloop-chat-box">
  <button class="verloop-loader-btn" (click)="loadChatBox()" mat-fab>
    <span *ngIf="!isLoading" class="chat-icon"></span>
    <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  </button>
</div>